import Resource from '@/plugins/sdk/Resource'
import { UUID, DATETIME, DATE, ITEM } from '@/plugins/sdk/fields'
import ScheduledPickup from '@/plugins/sdk/resources/ScheduledPickup'

export default class extends Resource {
  static name = 'scheduledpickup_skip'

  static get fields () {
    return {
      id: new UUID(),
      date_from: new DATE(),
      date_to: new DATE(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      scheduled_pickup: new ITEM(ScheduledPickup)
    }
  }
}
